(function() {    
    let tlFreeGiftOfferClone;
    let popupWidgetClone ;
    let embedWidgetClone
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                val.getAllGiftOfRule = (rule) => {
                     // group rule ids need custom
                    const listRuleId = [23692, 23694, 23695, 23696, 23697, 23698, 23700, 23701, 23702, 23703, 23704, 23705, 23706, 23710, 23711, 23712, 23713, 23714, 23715, 23717, 23718, 23719, 23720, 23721, 23722, 23724, 23725, 23726, 23727, 23728, 23729, 23730, 23731, 23733, 23734, 23735, 23736, 23737, 23738, 23739, 23740, 23741, 23742, 23743, 23744, 23745, 23746, 23747, 23748, 23749, 23750, 23813, 23815, 23832];
                    const ruleId = rule.id;

                    let giftInCart = [];
                    let giftInTempCart = [];

                    if (listRuleId.includes(ruleId)) {
                        giftInCart = listRuleId.flatMap(
                            id => window.tlFreeGiftOffer.ruleIdMapGifts.get(id) ?? []
                        );

                        giftInTempCart = listRuleId.flatMap(
                            id => window.tlFreeGiftOffer.ruleIdMapGiftsInTempCart.get(id) ?? []
                        );
                    } else {
                        giftInCart = window.tlFreeGiftOffer.ruleIdMapGifts.get(ruleId) ?? [];
                        giftInTempCart = window.tlFreeGiftOffer.ruleIdMapGiftsInTempCart.get(ruleId) ?? [];
                    }

                    return [...giftInTempCart, ...giftInCart];
                }
                Object.defineProperty(val, "popupWidget", {
                    get() {
                        return popupWidgetClone;
                    },
                    set(newValue) {
                        if (newValue && !popupWidgetClone) {
                            newValue.renderGifts = (rule, gifts, canClaimCount) => {
                                const {
                                    id: ruleId,
                                    auto_add_gift: autoAddGift,
                                    is_gift_qty_fixed: isGiftQtyFixed,
                                } = rule;

                                const translation = window.tlFreeGiftOffer.popupWidget.getRuleTranslation(rule);
                                const addedGifts = window.tlFreeGiftOffer.ruleIdMapGifts.get(ruleId) ?? [];

                                const filteredGifts = gifts.filter(gift => gift.price <= 1600);
                                
                                return filteredGifts.map((giftData) => {
                                    const giftId = giftData.id;
                                    const finalPrice = window.tlFreeGiftOffer.popupWidget.getFinalPrice(rule, giftData.price, translation);
                                    const isGiftAdded = addedGifts.some((gift) => gift.id === giftId);
                                    const badgeQuantity = window.tlFreeGiftOffer.popupWidget.getGiftBadgeQuantity(rule, giftData, canClaimCount);

                                    return `
                                        <div class="salepify-popup-item salepify-popup-gift ${isGiftAdded && isGiftQtyFixed ? "salepify-popup-item--selected" : ""}" 
                                            id="salepify-popup-gift-${ruleId}-${giftId}" gift-id="${giftId}"
                                            data-search-title="${window.tlFreeGiftOffer.popupWidget.utils.escapeHtmlAttr(window.tlFreeGiftOffer.popupWidget.utils.normalizeSearchTitle(giftData.title))}"
                                        >
                                            <div class="salepify-popup-item__img salepify-popup-product-img">
                                                <img src="${giftData.image}" alt="" />
                                                ${badgeQuantity ? `<div class="salepify-popup-item__qty-badge">x${badgeQuantity}</div>` : ""}
                                            </div>

                                            <div class="salepify-popup-item__info">
                                                <div>
                                                    <div class="salepify-popup-item__title">${giftData.title}</div>
                                                    <div class="salepify-popup-item__price-group" style="align-items: center;">
                                                        <div class="salepify-popup-item__price">${finalPrice}</div>
                                                        <div>-</div>
                                                        <div class="salepify-popup-item__compare-at-price">${window.tlFreeGiftOffer.popupWidget.utils.displayMoney(giftData.price * 100)}</div>
                                                    </div>
                                                </div>
                                                ${ autoAddGift ? "" :`
                                                    <div class="salepify-popup-item__action ${isGiftQtyFixed ? "salepify-popup-item__action--fixed-qty" : ""}">
                                                        <button class="salepify-popup-item__select-btn"
                                                            ${isGiftQtyFixed
                                                                ? `onclick='window.tlFreeGiftOffer.popupWidget.handleChooseGift(${ruleId}, "${giftId}")'`
                                                                : `onclick='window.tlFreeGiftOffer.popupWidget.addGiftSelected(${ruleId}, "${giftId}")'`
                                                            }
                                                        >
                                                            ${translation.select_btn || translation.manual_choose_gift.select_btn}
                                                        </button>

                                                        <button class="salepify-popup-item__selected-btn"
                                                            onclick='window.tlFreeGiftOffer.popupWidget.handleChooseGift(${ruleId}, "${giftId}")'
                                                        >
                                                            ${translation.selected_btn || translation.manual_choose_gift.selected_btn}
                                                        </button>

                                                        <div class="salepify-popup-item__qty-selector">
                                                            <button class="salepify-popup-item__decrease-btn" onclick='window.tlFreeGiftOffer.popupWidget.decreaseGiftQuantity(${ruleId}, "${giftId}")'>
                                                                <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1Z" fill="white"/>
                                                                </svg>
                                                            </button>
                                                            
                                                            <input class="salepify-popup-item__qty-input" type="text" value="1" min="1" 
                                                                onchange='window.tlFreeGiftOffer.popupWidget.changeGiftQuantity(this, ${ruleId}, "${giftId}")' 
                                                            />

                                                            <button class="salepify-popup-item__increase-btn" onclick='window.tlFreeGiftOffer.popupWidget.increaseGiftQuantity(${ruleId}, "${giftId}")'>
                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5 0C5.55228 0 6 0.447715 6 1V4L9 4C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H6V9C6 9.55229 5.55228 10 5 10C4.44771 10 4 9.55229 4 9V6H1C0.447715 6 0 5.55228 0 5C5.96046e-08 4.44771 0.447715 4 1 4L4 4V1C4 0.447715 4.44771 0 5 0Z" fill="white"/>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                `}
                                            </div>

                                            <div class="salepify-popup-gift__discount-badge">${window.tlFreeGiftOffer.popupWidget.handleReplaceVariable(rule, window.tlFreeGiftOffer.popupWidget.getDiscountBadge(rule, translation))}</div>
                                        </div>
                                    `
                                }).join(" ")
                            }
                            popupWidgetClone = newValue;
                        }
                    },
                    configurable: true
                });
                Object.defineProperty(val, "embedWidget", {
                    get() {
                        return embedWidgetClone;
                    },
                    set(newValue) {
                        if (newValue && !embedWidgetClone) {
                            newValue.checkIfPopupEnabled = () => false
                            newValue.isPopupEnabled = false;
                            newValue.getGiftsHTML = (gifts, displayRule) => {
                                const {
                                    CONDITION_STATE: { MET_BEFORE_CLAIM },
                                    AUTO_ADD_TYPE: { SELECT_TO_ADD },
                                    MODULE: { BOGO },
                                    GIFT_TYPE: { VARIANT },
                                } = window.tlFreeGiftOffer.embedWidget.constants;
                                const {
                                    id: ruleId,
                                    discount_type: discountType,
                                    discount_value: discountValue,
                                    auto_add_gift: autoAddGift,
                                    auto_add_type: autoAddType,
                                    gift_type: giftType,
                                    type,
                                    is_gift_qty_fixed: isGiftQtyFixed,
                                    gift_qty: giftQty,
                                } = displayRule;
                                const isPopupEnabled = window.tlFreeGiftOffer.embedWidget.checkIfPopupEnabled(ruleId);
                                const ruleTranslation = window.tlFreeGiftOffer.embedWidget.getTranslationByRuleId(ruleId);
                                const {
                                    main_offer: { free_text: freeTextTranslation, select_button: selectButtonTranslation },
                                } = ruleTranslation;

                                const { conditionState } = window.tlFreeGiftOffer.getRuleState(ruleId);
                                const shouldShowSelectButton = type !== BOGO && !autoAddGift && conditionState === MET_BEFORE_CLAIM && !isPopupEnabled;
                                const shouldShowQuantityBadge = type === BOGO || (autoAddGift ? autoAddType === SELECT_TO_ADD && giftType === VARIANT : isGiftQtyFixed);

                                const filteredGifts = gifts.filter(gift => gift.price <= 1600);

                                return filteredGifts
                                    .map(({ id: giftId, handle, price, image, quantity, title }) => {
                                        const giftURL = `/products/${handle}?variant=${giftId}`;
                                        const discountedPrice = window.tlFreeGiftOffer.embedWidget.utils.getPriceAfterDiscount(price, discountType, discountValue);
                                        const discountedPriceText = discountedPrice > 0 ? window.tlFreeGiftOffer.embedWidget.utils.displayMoney(discountedPrice * 100) : freeTextTranslation;

                                        return `
                                            <div class="salepify-embed-widget__gift-item" gift-id="${giftId}" data-selected="false">
                                                <div class="salepify-embed-widget__gift-item-image-container">
                                                    <a class="salepify-embed-widget__gift-item-link" href="${giftURL}">
                                                        <img class="salepify-embed-widget__gift-item-image" src=${image} alt="Gift item image" />
                                                    </a>
                                                    <div class="salepify-embed-widget__gift-item-quantity-badge" data-state="${shouldShowQuantityBadge ? "shown" : "hidden"}">
                                                        x${quantity ?? giftQty}
                                                    </div>
                                                </div>
                                                <div class="salepify-embed-widget__gift-item-info">
                                                    <a class="salepify-embed-widget__gift-item-link" href="${giftURL}">
                                                        <div class="salepify-embed-widget__gift-item-title">${title}</div>
                                                    </a>
                                                    <div class="salepify-embed-widget__gift-item-prices">
                                                        <div class="salepify-embed-widget__gift-item-price--discounted">${discountedPriceText}</div>
                                                        <span>-</span>
                                                        <div class="salepify-embed-widget__gift-item-price--original">${window.tlFreeGiftOffer.embedWidget.utils.displayMoney(price * 100)}</div>
                                                    </div>
                                                    <div class="salepify-embed-widget__gift-item-actions" gift-id="${giftId}">
                                                        <button
                                                            class="salepify-embed-widget__select-button"
                                                            data-state="${shouldShowSelectButton ? "shown" : "hidden"}"
                                                            onclick="${
                                                                isGiftQtyFixed
                                                                    ? `window.tlFreeGiftOffer.embedWidget.handleSelectGift(this, ${giftId})`
                                                                    : `window.tlFreeGiftOffer.embedWidget.handleAddGift(this, ${giftId})`
                                                            }"
                                                        >
                                                            ${selectButtonTranslation}
                                                        </button>
                                                        <div class="salepify-embed-widget__gift-item-quantity-selector" data-state="hidden">
                                                            <button
                                                                class="salepify-embed-widget__gift-item-quantity-button salepify-embed-widget__gift-item-quantity-button--decrease"
                                                                onclick="window.tlFreeGiftOffer.embedWidget.handleDecreaseGiftQuantity(this, ${giftId})"
                                                            >
                                                                -
                                                            </button>
                                                            <input
                                                                class="salepify-embed-widget__gift-item-quantity-input"
                                                                gift-id="${giftId}"
                                                                type="text"
                                                                value="1"
                                                                onchange="window.tlFreeGiftOffer.embedWidget.handleChangeGiftQuantity(this, ${giftId})"
                                                            />
                                                            <button
                                                                class="salepify-embed-widget__gift-item-quantity-button salepify-embed-widget__gift-item-quantity-button--increase"
                                                                onclick="window.tlFreeGiftOffer.embedWidget.handleIncreaseGiftQuantity(this, ${giftId})"
                                                            >
                                                                +
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        `;
                                    })
                                    .join("");
                            }
                            embedWidgetClone = newValue;
                        }
                    },
                    configurable: true
                });
            }
        },
        configurable: true
    });
})();